<!--课程名称-->
<template>
  <div>
    <h2><i
        v-if="courseName && courseName.substr(0,1)=='【'"
        class="title-special-processing"
      />{{courseName}}</h2>
    <h3 v-if="brief">{{brief}}</h3>
  </div>

</template>

<script>
export default {
  props: ['courseName', 'brief'],
};
</script>

<style lang="scss" scoped>
h2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #000;
  font-weight: 600;
  font-size: 33px;
  line-height: 45px;
}
h3 {
  font-size: 22px;
  font-weight: 400;
  color: #666666;
  line-height: 31px;
  margin-top: 20px;
}
</style>
